module.exports = __webpack_public_path__ + "img/estsuelcon-og.7616e058.png";